import { NumberFormatCustomValues } from '@lfg/ui/components';

export const isAllowedPercentage = (values: NumberFormatCustomValues) =>
  !values.floatValue || (values.floatValue > 0 && values.floatValue <= 100);

export const isAllowedGreadterThanZero = (values: NumberFormatCustomValues) =>
  !values.floatValue || values.floatValue > 0;
